class ReturnsAggregatorComponent extends HTMLElement {
  connectedCallback() {
    this.countryUrls = {};
    this.fallbackUrl = this.getAttribute('data-fallback-url') || '';
    this.selectedCountryCode = this.getAttribute('data-current-country') || '';

    try {
      this.countryUrls = JSON.parse(this.getAttribute('data-country-urls') || '{}');
    } catch (e) {
      // Fall back to empty map
    }

    this.trigger = this.querySelector('[data-ref="trigger"]');
    this.triggerLabel = this.querySelector('[data-ref="triggerLabel"]');
    this.dropdown = this.querySelector('[data-ref="dropdown"]');
    this.search = this.querySelector('[data-ref="search"]');
    this.list = this.querySelector('[data-ref="list"]');
    this.noResults = this.querySelector('[data-ref="noResults"]');
    this.cta = this.querySelector('[data-ref="cta"]');
    this.items = [...this.list.querySelectorAll('[role="option"]')];

    this.trigger.addEventListener('click', () => this.toggleDropdown());

    this.trigger.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        this.openDropdown();
      } else if (e.key.length === 1 && !e.ctrlKey && !e.metaKey) {
        this.openDropdown();
        this.search.value = e.key;
        this.filterCountries();
      }
    });

    this.search.addEventListener('input', () => this.filterCountries());
    this.list.addEventListener('click', (e) => {
      const item = e.target.closest('[role="option"]:not([hidden])');
      if (item && item !== this.noResults) this.selectCountry(item);
    });

    document.addEventListener('click', (e) => {
      const isDropdown = this.dropdown.contains(e.target);
      const isTrigger = this.trigger.contains(e.target);
      const isCta = this.cta && this.cta.contains(e.target);
      if (!isDropdown && !isTrigger && !isCta) this.closeDropdown();
    });

    this.search.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        const first = this.items.find((item) => !item.hidden);
        if (first) first.focus();
      } else if (e.key === 'Escape') {
        this.closeDropdown();
      }
    });

    this.list.addEventListener('keydown', (e) => {
      const focused = document.activeElement;
      if (!focused || !focused.matches('[role="option"]')) return;

      const visible = this.items.filter((item) => !item.hidden);
      const index = visible.indexOf(focused);

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (index < visible.length - 1) visible[index + 1].focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (index > 0) visible[index - 1].focus();
        else this.search.focus();
      } else if (e.key === 'Enter') {
        e.preventDefault();
        this.selectCountry(focused);
      } else if (e.key === 'Escape') {
        this.closeDropdown();
      }
    });

    this.updateCtaUrl();
  }

  toggleDropdown() {
    if (this.dropdown.hidden) {
      this.openDropdown();
    } else {
      this.closeDropdown();
    }
  }

  openDropdown() {
    this.dropdown.hidden = false;
    this.trigger.setAttribute('aria-expanded', 'true');
    this.search.value = '';
    this.filterCountries();
    this.search.focus();
  }

  closeDropdown() {
    this.dropdown.hidden = true;
    this.trigger.setAttribute('aria-expanded', 'false');
  }

  filterCountries() {
    const query = this.search.value.toLowerCase().trim();
    let visibleCount = 0;

    this.items.forEach((item) => {
      if (item === this.noResults) return;

      const name = (item.getAttribute('data-country-name') || '').toLowerCase();
      const iso = (item.getAttribute('data-value') || '').toLowerCase();
      const aliases = (item.getAttribute('data-aliases') || '').toLowerCase();

      const match = !query || name.includes(query) || iso.includes(query) || aliases.includes(query);
      item.hidden = !match;
      if (match) visibleCount++;
    });

    this.noResults.hidden = visibleCount > 0;
  }

  selectCountry(item) {
    this.items.forEach((i) => i.setAttribute('aria-selected', 'false'));
    item.setAttribute('aria-selected', 'true');

    this.selectedCountryCode = item.getAttribute('data-value');
    this.triggerLabel.textContent = item.getAttribute('data-country-name');

    this.updateCtaUrl();
    this.closeDropdown();
    this.trigger.focus();
  }

  updateCtaUrl() {
    const url = this.countryUrls[this.selectedCountryCode] || this.fallbackUrl;
    if (this.cta && url) {
      this.cta.href = url;
    }
  }
}

if (!customElements.get('returns-aggregator-component')) {
  customElements.define('returns-aggregator-component', ReturnsAggregatorComponent);
}
